import AnonymousTravellerLgIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/account-circle';
import SoloTravellerLgIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/adult';
import BusinessTravellerLgIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/business';
import FamilyTravellerLgIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/family';
import CoupleTravellerLgIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/toilets';
import AnonymousTravellerIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/account-circle';
import SoloTravellerIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/adult';
import BusinessTravellerIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/business';
import FamilyTravellerIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/family';
import CoupleTravellerIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/toilets';
import {
  textSecondaryDay,
  statusDangerFillDay,
  statusWarningFillNight,
  statusSuccessFillDay,
  lineDay,
} from '@skyscanner/bpk-foundations-web/tokens/base.es6';

import { GroupTravellerIcon, GroupTravellerLgIcon } from '../common/img';

const TravellerInfoMapping: any = {
  business: {
    icon: BusinessTravellerIcon,
    iconLg: BusinessTravellerLgIcon,
    backgroundColor: textSecondaryDay,
  },
  couple: {
    icon: CoupleTravellerIcon,
    iconLg: CoupleTravellerLgIcon,
    backgroundColor: statusDangerFillDay,
  },
  family: {
    icon: FamilyTravellerIcon,
    iconLg: FamilyTravellerLgIcon,
    backgroundColor: statusWarningFillNight,
  },
  group: {
    icon: GroupTravellerIcon,
    iconLg: GroupTravellerLgIcon,
    backgroundColor: textSecondaryDay,
  },
  solo: {
    icon: SoloTravellerIcon,
    iconLg: SoloTravellerLgIcon,
    backgroundColor: statusSuccessFillDay,
  },
  other: {
    icon: AnonymousTravellerIcon,
    iconLg: AnonymousTravellerLgIcon,
    backgroundColor: lineDay,
  },
};

export default TravellerInfoMapping;
